export const welcomeJomatik = {
  welcomeToMurtfeldtAS: "Bienvenue à Murtfeldt Additive Solutions.",
  dearJomatikCustomer: "Cher client,",
  happyToSeeYou:
    'JOMATIK fait désormais partie du groupe Murtfeldt et a été rebaptisé Murtfeldt Additive Solutions. Pour cette raison, nous restructurons notre présence en ligne. <span class="has-text-primary">www.murtfeldt-as.de</span>.',
  nameChange: "s'appelle maintenant",
  everythingAsNormal: "Pour vous, cela signifie",
  sameTeam: "Nous vous proposons dès à présent une gamme de services élargie,",
  sameService: "Nous sommes la même équipe et nous sommes toujours à Tübingen,",
  sameLogin:
    "Vous pouvez vous connecter chez nous avec vos données d'accès habituelles.",
  discount:
    'Pour vous remercier de votre fidélité passée, vous bénéficierez d\'une réduction de  <span class="has-text-primary">{amount}%</span> sur votre prochaine commande grâce au coupon <span class="has-text-info">{code}</span>.',
  thankYou:
    "Nous vous remercions de votre confiance et nous réjouissons de poursuivre notre collaboration.<br> L'équipe de Murtfeldt Additive Solutions ",
  marketPlaceNote:
    'Nous vous demandons d\'utiliser notre nouvelle plateforme  <br/><span class="has-text-primary">murtfeldt-as.de</span> pour vos futures commandes. Cependant, nous allons maintenir la place de marché Jomatik en ligne pendant un certain temps.',
  goToStart: "Continuer vers le nouveau portail",
  goToMarketPlace: "Aller au marché de JOMATIK",
};
